var render = function () {
  var _vm$dataModel$service, _vm$dataModel$startTi, _vm$dataModel$branchF;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3 liff-reservation-success"
  }, [_vm.finishedPageTitle ? _c('div', {
    staticClass: "liff-reservation-success__title"
  }, [_vm._v(_vm._s(_vm.finishedPageTitle || '預約成功！'))]) : _vm._e(), _vm.finishedPageContent ? _c('div', {
    staticClass: "liff-reservation-success__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.finishedPageContent)
    }
  }) : _vm._e(), _c('b-card', {
    staticClass: "mb-3 wizard-mode-layout__card",
    attrs: {
      "header-tag": "header"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.bookingPreset.config.finished_page.booking_person_title || '預約人資訊'))])])];
      },
      proxy: true
    }])
  }, [_vm.bookingPreset.config.finished_page.enabled_booking_person_custom_fields ? _vm._l(_vm.bookingPreset.config.finished_page.booking_person, function (field) {
    return _c('b-form-group', {
      key: field.order,
      staticClass: "mb-3",
      attrs: {
        "label": field.title,
        "label-cols": "4",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label-for": "input-sm"
      }
    }, [_c('div', {
      staticClass: "text-right s-text-sm"
    }, [_vm._v(_vm._s(_vm.getFieldValue(field.matched_key) || ''))])]);
  }) : [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "姓名",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm.user.mobile_phone ? _c('b-form-group', {
    attrs: {
      "label": "電話",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.user.mobile_phone))])]) : _vm._e()]], 2), _c('b-card', {
    staticClass: "mb-3 wizard-mode-layout__card",
    attrs: {
      "header-tag": "header"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.bookingPreset.config.finished_page.booking_info_title || '預約資訊'))])])];
      },
      proxy: true
    }])
  }, [_vm.bookingPreset.config.finished_page.enabled_booking_info_custom_fields ? _vm._l(_vm.bookingPreset.config.finished_page.booking_info, function (field) {
    return _c('b-form-group', {
      key: field.order,
      staticClass: "mb-3",
      attrs: {
        "label": field.title,
        "label-cols": "4",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label-for": "input-sm"
      }
    }, [_c('div', {
      staticClass: "text-right s-text-sm"
    }, [_vm._v(_vm._s(_vm.getFieldValue(field.matched_key) || ''))])]);
  }) : [_vm.selectedServices.length ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": (_vm$dataModel$service = _vm.dataModel.serviceField) === null || _vm$dataModel$service === void 0 ? void 0 : _vm$dataModel$service.title,
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedServices.map(function (service) {
    return service.title;
  }).join(', ')))])]) : _vm._e(), _vm.selectedStaff.name ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "服務人員",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedStaff.name))])]) : _vm._e(), _vm.selectedScheduleLabel ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": (_vm$dataModel$startTi = _vm.dataModel.startTimeField) === null || _vm$dataModel$startTi === void 0 ? void 0 : _vm$dataModel$startTi.title,
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedScheduleLabel))])]) : _vm._e(), _vm.endDateTimeForDisplay && !_vm.dataModel.shouldHideEndTime ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "預約結束時間",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.endDateTimeForDisplay.format(_vm.dataModel.startAtFieldFormatIsDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')))])]) : _vm._e(), _vm.selectedBranch.name ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": (_vm$dataModel$branchF = _vm.dataModel.branchField) === null || _vm$dataModel$branchF === void 0 ? void 0 : _vm$dataModel$branchF.title,
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedBranch.name))])]) : _vm._e()]], 2), _vm.fields.length > 0 ? _c('b-card', {
    staticClass: "mb-3 wizard-mode-layout__card",
    attrs: {
      "header-tag": "header"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.bookingPreset.config.finished_page.form_content_title || '其他資訊'))])])];
      },
      proxy: true
    }], null, false, 3055077487)
  }, [_vm.bookingPreset.config.finished_page.enabled_form_content_custom_fields ? _vm._l(_vm.bookingPreset.config.finished_page.form_content, function (field) {
    return _c('b-form-group', {
      key: field.order,
      staticClass: "mb-3",
      attrs: {
        "label": field.title,
        "label-cols": "4",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label-for": "input-sm"
      }
    }, [_c('div', {
      staticClass: "text-right s-text-sm"
    }, [_vm._v(_vm._s(_vm.getFieldValue(field.matched_key) || ''))])]);
  }) : _vm._l(_vm.fields, function (field) {
    return _c('b-form-group', {
      key: field._id,
      staticClass: "mb-3",
      attrs: {
        "label": field.title,
        "label-cols": "4",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label-for": "input-sm"
      }
    }, [_c('div', {
      staticClass: "text-right s-text-sm"
    }, [_vm._v(_vm._s(_vm.extraFormData[field._id]))])]);
  })], 2) : _vm._e(), _c('div', [_vm.showNextBookingButton ? _c('ShareButton', {
    staticClass: "mb-2",
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.$router.push({
          name: _vm.dataModel.nextWizardStep('LiffReservation'),
          params: {
            bookingPresetId: _vm.$route.params.bookingPresetId
          }
        });
      }
    }
  }, [_vm._v(" 繼續預約 ")]) : _vm._e(), _vm.showGoBookingListButton ? _c('ShareButton', {
    staticClass: "mb-2",
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffBookingPreset',
          params: {
            presetId: _vm.$route.params.bookingPresetId
          }
        });
      }
    }
  }, [_vm._v(" 預約紀錄 ")]) : _vm._e(), _c('MemberButton', {
    attrs: {
      "button-text": "回 LINE 官方帳號",
      "type": "OA"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }